import React, { useState } from "react";
import {
  Fab,
  Popover,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Backdrop,
  Checkbox,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import CloseIcon from "@mui/icons-material/Close";
import AssignProject from "../../../../../components/Form/AssignProject";
import { useForm } from "react-hook-form";
import AssignTo from "../../../../../components/Form/AssignTo";
import useAssignees from "../../../../../components/CommonFunctions/Usres";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Dropdowns from "./elements/Dropdowns";
import { WhatsappTemplatesAPI } from "../../../../../api/Endpoints/WhatsappTemplateAPI";
import LeadConvertPopup from "../../../../../components/Popup/LeadConvertPopup";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
function WhatsappLeadConverter({ leads, func, loading }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { watch, setValue, control } = useForm();
  const { assignees, isLoading } = useAssignees();
  const [showDrps, setShowDrps] = useState(false);
  // State for selected leads
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [storeIds, setStoreIds] = useState([]); // Ensure storeIds is an array
  const [formButtonStatus, setFormButtonStatus] = useState({
    label: "Convert",
    loading: false,
    disabled: false,
  });
  // Handle opening popover
  const handleClick = (event) => {
    setSelectedLeads([]);
    setValue("assigned_to_details", null);
    setValue("assign_project", null);
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  // Toggle selection for a single lead
  const handleSelectLead = (id) => {
    if (storeIds.length > 0) {
      setStoreIds([]);
      setValue("assigned_to_details", null);
      setValue("assign_project", null);
    }
    setSelectedLeads((prev) =>
      prev.includes(id) ? prev.filter((leadId) => leadId !== id) : [...prev, id]
    );
  };

  // Select or Deselect all leads
  const handleSelectAll = (event) => {
    setSelectedLeads(event.target.checked ? leads.map((lead) => lead.id) : []);
  };

  const open = Boolean(anchorEl);
  const id = open ? "whatsapp-popover" : undefined;

  const NextButtonHandler = () => {
    setShowDrps(true);
  };

  const handleSend = async () => {
   
    setFormButtonStatus({ ...formButtonStatus, loading: true, disabled: true });
    const data = {
      leads: selectedLeads.map((leadId, index) => ({
        id: leadId,
        assigned_to: watch("assing_to_users")?.id || null,
        project_id: watch("assign_project")?.id || null,
      })),
    };

    const res = await WhatsappTemplatesAPI.WhatsappLeadConverter(data);
    console.log(res);
    if (res) {
      toast.success("Successfully Converted", { autoClose: 2000 });
      setFormButtonStatus({
        ...formButtonStatus,
        loading: false,
        disabled: false,
      });
      setShowDrps(false);
      setStoreIds([]);
      setValue("assigned_to_details", null);
      setValue("assign_project", null);
      func && func();
    } else {
      setFormButtonStatus({
        ...formButtonStatus,
        loading: false,
        disabled: false,
      });
    }
  };
  const directSend = (ids) => {
    setStoreIds(ids);
  };

  const [showconvertPopup, setShowconvertPopup] = useState(false);

  const handleBack = () => {
    setShowDrps(false);
  };

  return (
    <div>
      <Button
        sx={{
          position: "absolute",
          top: 3,
          color: "white",
          right: 16,
          backgroundColor: "#3E9E7C",
          zIndex: 1301,
          ":hover": { backgroundColor: "#3E9E7C" },
        }}
        component="span"
        onClick={handleClick}
      >
        {/* {!open ? (
          <ArrowOutwardIcon sx={{ color: "white", fontSize: 30 }} />
        ) : (
          <CloseIcon sx={{ color: "white", fontSize: 30 }} />
        )} */}
        New Whatsapp Leads
      </Button>

      <Backdrop
        open={open}
        sx={{ zIndex: 1300, backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
      
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box width={500}>
          {!showDrps ? (
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 350, overflowY: "auto" }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Checkbox
                        checked={selectedLeads.length === leads.length}
                        indeterminate={
                          selectedLeads.length > 0 &&
                          selectedLeads.length < leads.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Phone Number</TableCell>
                    <TableCell>Assign To</TableCell>
                    <TableCell>Project</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading
                    ? Array.from({ length: 8 }).map(
                        (
                          _,
                          index // Adjust the number of skeleton rows as needed
                        ) => (
                          <TableRow key={index}>
                            <TableCell>
                              <Skeleton variant="rectangular" height={24} />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="rectangular" height={30} />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="rectangular" height={30} />
                            </TableCell>
                          </TableRow>
                        )
                      )
                    : leads &&
                      leads.map((lead) => (
                        <TableRow
                          key={lead.id}
                          sx={{
                            backgroundColor:
                              Array.isArray(storeIds) &&
                              selectedLeads.includes(lead.id)
                                ? "#E3F2FD"
                                : "inherit",
                          }}
                        >
                          <TableCell>
                            <Checkbox
                              checked={selectedLeads.includes(lead.id)}
                              onChange={() => handleSelectLead(lead.id)}
                            />
                          </TableCell>
                          <TableCell>{lead.name}</TableCell>
                          <TableCell>{lead.phone_number}</TableCell>
                          <TableCell>
                            <Button onClick={() => directSend(lead.id)}>
                              <AssignTo
                                LeadConverter={true}
                                id={lead.id}
                                name={`assigned_to_details`}
                                assignees={assignees}
                                isLoading={isLoading}
                                setValue={setValue}
                                watch={watch}
                              />
                            </Button>
                          </TableCell>
                          <TableCell>
                            <Button onClick={() => directSend(lead.id)}>
                              <AssignProject
                                LeadConverter={true}
                                id={lead.id}
                                name={`assign_project`}
                                setValue={setValue}
                                watch={watch}
                                func={func}
                              />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ height: 200, overflowY: "auto" }}>
              <Dropdowns watch={watch} setValue={setValue} control={control} />
            </Box>
          )}

          {/* Send Button (Only Show If Leads are Selected) */}
          {selectedLeads.length > 0 ? (
            <Box
              width={"100%"}
              display={"flex"}
              justifyContent={"flex-end"}
              alignContent={"center"}
              mt={1}
            >
              {showDrps && (
                <Button
                  sx={{
                    background: "#FAAB53",
                    color: "white",
                    mr: 1,
                    ":hover": { background: "#FAAB53" },
                  }}
                  onClick={handleBack}
                >
                  <ArrowBackIcon fontSize="small" />{" "}
                </Button>
              )}

              {showDrps &&watch("assign_project") && watch("assing_to_users") && (
                <LoadingButton
                  loading={formButtonStatus.loading}
                  disabled={formButtonStatus.disabled}
                  variant="outlined"
                  color="primary"
                  type="submit"
                  sx={{
                    background: "#FAAB53",
                    color: "white",
                    ":hover": { background: "#FAAB53" },
                  }}
                  onClick={handleSend}
                >
                  {" "}
                  {"Convert"}
                </LoadingButton>
              ) }
           {!showDrps&&
            <Button
            sx={{
              background: "#FAAB53",
              color: "white",
              ":hover": { background: "#FAAB53" },
            }}
            onClick={NextButtonHandler}
          >
            <ArrowForwardIcon fontSize="small" />
          </Button>
           }    
              
            </Box>
          ) : watch("assign_project") && watch("assing_to_users") ? (
            <LeadConvertPopup
              setShowPopup={setShowconvertPopup}
              leadsId={storeIds}
              setProjectID={setStoreIds}
              frmWhatsappLeadConvertPage={true}
              func={func}
              assigned_to={watch("assing_to_users")?.id || null}
              ProjectID={watch("assign_project")?.id || null}
              setValue={setValue}
            />
          ) : null}
        </Box>
      </Popover>
    </div>
  );
}

export default WhatsappLeadConverter;
